import React, { useState } from 'react'
 
import AssignSalesRegionForm from './AssignSalesRegionForm';
import AssignSalesRegionList from './AssignSalesRegionList';

const AssignSalesRegion= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AssignSalesRegionForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AssignSalesRegionList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AssignSalesRegion